import { FC, SVGProps } from 'react';

const svgModules = import.meta.glob<FC<SVGProps<SVGSVGElement>>>(
  '../assets/icon/*.svg',
  {
    eager: true,
    import: 'default',
    query: '?react',
  }
);

// Build a map of icon name -> component
const icons: Record<string, FC<SVGProps<SVGSVGElement>>> = Object.entries(
  svgModules
).reduce((map, [path, Component]) => {
  const match = /\/([^/]+)\.svg$/.exec(path);
  if (match) map[match[1]] = Component;
  return map;
}, {} as Record<string, FC<SVGProps<SVGSVGElement>>>);

interface IconSVGProps extends SVGProps<SVGSVGElement> {
  // Filename (without ".svg") in /src/assets/icon
  name: string;
  color?: string;
}

const IconSVG: FC<IconSVGProps> = ({ name, color, ...props }) => {
  const Svg = icons[name];
  if (!Svg) {
    console.warn(
      `Icon '${name}' not found. Check '/src/assets/icon/${name}.svg'.`
    );
    return null;
  }

  const size = window.innerWidth < 767 ? 32 : 42;
  return <Svg fill={color} width={size} height={size} {...props} />;
};

export default IconSVG;
